import { render, staticRenderFns } from "./MyCare.vue?vue&type=template&id=6d23ed52&scoped=true"
import script from "./MyCare.vue?vue&type=script&lang=js"
export * from "./MyCare.vue?vue&type=script&lang=js"
import style0 from "./MyCare.vue?vue&type=style&index=0&id=6d23ed52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23ed52",
  null
  
)

export default component.exports